import script from "./VPageHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./VPageHeader.vue?vue&type=script&setup=true&lang=ts"

import "./VPageHeader.vue?vue&type=style&index=0&id=688217a5&lang=scss"

const __exports__ = script;

export default __exports__